import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

/**
 * A simple layout component that organizes fields into sections arranged horizontally
 * @param {Object} props
 * @param {Array} props.sections - Array of section objects with title and fields
 */
const SectionedShowLayout = ({ sections = [] }) => {
    if (!sections.length) {
        return null;
    }

    return (
        <Box sx={{ p: 2 }}>
            {sections.map((section, index) => (
                <Box key={section.title || `section-${index}`} sx={{ mb: 1, backgroundColor: '#fafafa', borderRadius: 1 }}>
                    {section.title && (
                        <Typography 
                            variant="h6" 
                            sx={{ 
                                fontWeight: 500,
                                borderBottom: '1px solid #ddd',
                                pb: 1
                            }}
                        >
                            {section.title}
                        </Typography>
                    )}
                    <Grid container spacing={1}>
                        {section.fields && section.fields.map((field, fieldIndex) => (
                            <Grid 
                                item 
                                xs={12} 
                                sm={6} 
                                md={4} 
                                key={fieldIndex}
                            >
                                <Box>
                                    {field}
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            ))}
        </Box>
    );
};

export default SectionedShowLayout;
